import { render, staticRenderFns } from "./AddBathroom.vue?vue&type=template&id=4780a333"
import script from "./AddBathroom.vue?vue&type=script&lang=js"
export * from "./AddBathroom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports